import React, {useState, useContext, useRef, useCallback} from 'react'
import {I18nContext} from '@/context/i18n/I18nContext'
import QuickSelect from './QuickSelect'
import type {RecipientToAdd, QuickSelectI18nScope} from './QuickSelect'

interface Props {
  currentUser: {id: number; role: string}
  currentInstituteId: number
  currentInstituteType: string
  currentInstituteHasStudentSquare: boolean
  addRecipients: (recipients: RecipientToAdd[]) => void
  maximumRecipientsToAdd: () => number
  initialRecipients: () => Set<number>
  isPrivateChat: boolean
}

const QuickSelectButton = ({
  currentUser,
  currentInstituteId,
  currentInstituteType,
  currentInstituteHasStudentSquare,
  addRecipients,
  maximumRecipientsToAdd,
  initialRecipients,
  isPrivateChat,
}: Props) => {
  const i18n = useContext(I18nContext) as QuickSelectI18nScope
  const i18nQS = i18n.quick_select
  const [opened, setOpened] = useState(false)
  const triggerRef = useRef<HTMLButtonElement>(null)
  const open = () => setOpened(true)
  const close = useCallback(() => {
    setOpened(false)
    triggerRef.current?.focus()
  }, [])

  return (
    <>
      <button
        type="button"
        onClick={open}
        className="quick-select-button"
        ref={triggerRef}
        data-testid="chat-quick-select-trigger"
      >
        {i18nQS.add_by_quick_select_button}
      </button>
      {opened && (
        <QuickSelect
          closeModal={close}
          currentUser={currentUser}
          currentInstituteId={currentInstituteId}
          currentInstituteType={currentInstituteType}
          currentInstituteHasStudentSquare={currentInstituteHasStudentSquare}
          onAddRecipientsClick={addRecipients}
          maximumRecipientsToAdd={maximumRecipientsToAdd}
          initialRecipients={initialRecipients}
          isPrivateChat={isPrivateChat}
        />
      )}
    </>
  )
}

export default QuickSelectButton
